import FormGroup from "legacy/FormGroup"
import { humanize } from "legacy/helpers.es6"
import SelectCreditCardSection from "legacy/new-reservation-form/SelectCreditCardSection"
import _ from "lodash"
import PropTypes from "prop-types"
import React from "react"

class PaymentDetailsSection extends React.Component {
  constructor(props) {
    super(props)
    this.cardSection = this.cardSection.bind(this)
    this.renderBillingCycle = this.renderBillingCycle.bind(this)
  }

  cardSection() {
    if (this.props.creditCard) {
      return (
        <div className="col-md-5">
          <SelectCreditCardSection
            endpoint={this.props.cardCreatePath}
            userCards={this.props.userCards}
            selectedCardId={this.props.selectedCardId}
            setStripeCard={this.props.setStripeCard}
          />
          {this.props.validator.message(
            "creditCard",
            this.props.selectedCardId,
            "required|not_in:add_new_card",
            {
              messages: {
                default: "A credit card is required with this payment type.",
              },
            }
          )}
        </div>
      )
    }
    return null
  }

  renderBillingCycle() {
    return (
      <div className={this.props.creditCard ? "col-md-3" : "col-md-6"}>
        <FormGroup
          inputType="select"
          label="Billing Cycle"
          name="billingCycle"
          value={
            this.props.savedOrCustomRateApplied ? "" : this.props.billingCycle
          }
          onChange={this.props.handleInputChange}
          disabled={this.props.savedOrCustomRateApplied}
        >
          {_.map(this.props.billingCycles, (billingCycle) => (
            <option key={billingCycle} value={billingCycle}>
              {humanize(billingCycle)}
            </option>
          ))}
        </FormGroup>
        {this.props.savedOrCustomRateApplied && (
          <div className="text-muted">Configure in the installment rate.</div>
        )}
      </div>
    )
  }

  render() {
    return (
      <div>
        <h4 className="bs-mt-0 font-semibold">Payment</h4>
        <div className="row form-row">
          {this.renderBillingCycle()}
          <div className={this.props.creditCard ? "col-md-4" : "col-md-6"}>
            <FormGroup
              inputType="select"
              label="Autopay"
              name="paymentMethod"
              value={this.props.paymentMethod}
              onChange={this.props.handleInputChangeNoReload}
            >
              <option value="credit">Enabled</option>
              <option value="manual">Disabled (Settle Manually)</option>
            </FormGroup>
          </div>
          {this.cardSection()}
        </div>
      </div>
    )
  }
}

PaymentDetailsSection.propTypes = {
  billingCycle: PropTypes.string,
  billingCycles: PropTypes.array.isRequired,
  cardCreatePath: PropTypes.string,
  creditCard: PropTypes.bool,
  handleInputChange: PropTypes.func.isRequired,
  handleInputChangeNoReload: PropTypes.func.isRequired,
  paymentMethod: PropTypes.string.isRequired,
  savedOrCustomRateApplied: PropTypes.bool,
  selectedCardId: PropTypes.string,
  setStripeCard: PropTypes.func.isRequired,
  userCards: PropTypes.array,
  validator: PropTypes.object.isRequired,
}

export default PaymentDetailsSection
